import { useEmployeeAppConfigStore } from "@/stores/employee.store.ts";
import { EmojiDisplay, sidebarTheme } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export function AiAssistantRailButton() {
  const { t } = useTranslation();
  const { aiAssistantIsOpen, aiAssistantWasOpened, setAiAssistantIsOpen } =
    useEmployeeAppConfigStore();
  const label = t("ai:assistant_name");

  return (
    <button
      type={"button"}
      title={t("ai:assistant_title")}
      aria-label={t("ai:assistant_title")}
      aria-expanded={aiAssistantIsOpen}
      onClick={() => setAiAssistantIsOpen(!aiAssistantIsOpen)}
      className={sidebarTheme.more.trigger}
    >
      <span
        className={twMerge(
          sidebarTheme.item.iconBox,
          "relative",
          aiAssistantIsOpen && sidebarTheme.item.iconBoxActive
        )}
      >
        <EmojiDisplay id={aiAssistantWasOpened ? "sloth" : "otter"} size={"md"} />
        {!aiAssistantWasOpened && (
          <span
            aria-hidden={true}
            className={twMerge(sidebarTheme.item.badge, "h-3 w-3 rounded-full bg-warning")}
          />
        )}
      </span>
      <span className={sidebarTheme.item.label}>{label}</span>
    </button>
  );
}
